import { render, staticRenderFns } from "./extra-details-close-delay.vue?vue&type=template&id=2a3b90d4&"
import script from "./extra-details-close-delay.vue?vue&type=script&lang=js&"
export * from "./extra-details-close-delay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports